import { fetchQuery, useRelayEnvironment, graphql } from 'react-relay';
import { useState } from 'react';
import type { FC, PropsWithChildren } from 'react';
import Button from '../Button';
import { DownloadFileHelper } from '../DownloadFileHelper';
import { API_URL } from '../../services/url';
import type {
    DownloadRawDataButtonQuery,
    RawDataColumnFilter,
} from './__generated__/DownloadRawDataButtonQuery.graphql';

export type DownloadRawDataButtonProps = PropsWithChildren<{
    questionnaireId: string;
    columnFilters?: Array<RawDataColumnFilter>;
}>;

export const DownloadRawDataButton: FC<DownloadRawDataButtonProps> = (
    props,
) => {
    const relayEnvironment = useRelayEnvironment();
    const [loading, setLoading] = useState(false);
    const [url, setUrl] = useState('');
    const onClickDownloadRawData = async () => {
        setLoading(true);
        const result = await fetchQuery<DownloadRawDataButtonQuery>(
            relayEnvironment,
            graphql`
                query DownloadRawDataButtonQuery(
                    $questionnaireId: ID!
                    $columnFilters: [RawDataColumnFilter!]
                ) {
                    rawData: exportRawData(
                        questionnaireId: $questionnaireId
                        textReplacementFields: [
                            "teamName"
                            "projectName"
                            "surveyNumber"
                        ]
                        columnFilters: $columnFilters
                        format: Csv
                    ) {
                        path
                    }
                }
            `,
            {
                questionnaireId: props.questionnaireId,
                columnFilters: props.columnFilters || [],
            },
        )
            .toPromise()
            .finally(() => {
                setLoading(false);
            });
        if (result?.rawData) {
            setUrl(API_URL + result.rawData.path);
        }
    };
    return (
        <>
            <Button
                variant="text"
                disabled={loading}
                onClick={onClickDownloadRawData}
            >
                {props.children}
            </Button>
            <DownloadFileHelper
                noDialog
                url={url}
                open={url !== ''}
                onClose={() => {
                    setUrl('');
                }}
            />
        </>
    );
};
